<template>
  <div class="dash-header">
    <div class="dash-header-top">
      <div class="dash-header-left">
        <h1 class="dash-title">{{ title }}</h1>
        <p class="dash-sub">{{ subText }}</p>
      </div>
      <div class="dash-meta">
        <div class="dash-meta-row" v-for="item in metaRows" :key="item.label">
          <span class="dash-meta-label">{{ item.label }}</span>
          <span class="dash-meta-value">{{ item.value }}</span>
        </div>
      </div>
    </div>
    <div class="dash-chips" v-if="chips && chips.length">
      <span class="dash-chip" v-for="chip in chips" :key="chip.label">
        <i class="chip-icon"></i>
        <span class="chip-label">{{ chip.label }}</span>
        <span class="chip-value">{{ chip.value }}</span>
      </span>
    </div>
  </div>
</template>
<script>
import { RULE_VERSION, DATA_SOURCE } from './impact'

export default {
  name: 'ImpactHeader',
  props: {
    title: { type: String, default: '' },
    tags: { type: Array, default: function () { return [] } },
    chips: { type: Array, default: function () { return [] } },
    loadedAt: { type: String, default: '' }
  },
  computed: {
    subText () {
      return ['Teacher Disruption Impact'].concat(this.tags).join(' / ')
    },
    metaRows () {
      return [
        { label: '数据来源', value: DATA_SOURCE },
        { label: '口径版本', value: RULE_VERSION },
        { label: '最近更新', value: this.loadedAt || '—' }
      ]
    }
  }
}
</script>
<style scoped lang="less">
@import './vars.less';

.dash-header {
  padding: 20px 24px 16px;
  border-radius: @radius-header;
  background: linear-gradient(90deg, @header-bg 0%, @header-bg-end 100%);
  color: #fff;
}

.dash-header-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: @gap;
}

.dash-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  color: #fff;
}

.dash-sub {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, .7);
}

.dash-meta {
  text-align: right;
  white-space: nowrap;
}

.dash-meta-row {
  font-size: 12px;
  line-height: 1.7;
}

.dash-meta-label {
  margin-right: 8px;
  color: rgba(255, 255, 255, .55);
}

.dash-meta-value {
  color: rgba(255, 255, 255, .92);
}

.dash-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.dash-chip {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 16px;
  background: rgba(255, 255, 255, .08);
  font-size: 12px;
  color: rgba(255, 255, 255, .88);
}

.chip-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 6px;
  border: 1px solid rgba(255, 255, 255, .55);
  border-radius: 50%;
}

.chip-label {
  margin-right: 6px;
}

.chip-value {
  font-weight: 600;
}

@media (max-width: 768px) {
  .dash-header-top {
    flex-direction: column;
  }
  .dash-meta {
    text-align: left;
    white-space: normal;
  }
}
</style>



// WEBPACK FOOTER //
// ImpactHeader.vue?23f3130e